module.exports = __webpack_public_path__ + "img/edit.68cf5717.png";